import { z } from "zod";

import { isThemeNamedColour, ThemeNamedColour } from "@holibob-packages/colour";

export const ThemeNamedColorSchema = z.custom<ThemeNamedColour>(isThemeNamedColour, "Invalid theme named colour");
